import {
  Button,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  Tag,
} from '@blueprintjs/core';
import styles from './RecordTags.module.css';
import { ace } from '@axo/shared/data-access/types';
import { ace_hooks } from '@axo/shared/data-access/hooks';

export function RecordTags({
  record,
  tags,
  disabled,
}: {
  record: ace.CallRecord;
  tags: ace.CallTag[];
  disabled?: boolean;
}) {
  const { mutate: patchCallRecord, isLoading } = ace_hooks.usePatchCallRecord();

  const availableTags: ace.CallTag[] = tags.filter(
    (tag) =>
      !record.Tags?.includes(tag.Name) &&
      !record.Tags?.includes(tag.ID) &&
      !tag.Disabled,
  );

  return (
    <div className={styles.callTags}>
      {record.Tags?.map((tag: string) => (
        <Tag
          key={tag}
          minimal
          onRemove={() =>
            !disabled &&
            !isLoading &&
            patchCallRecord({
              id: record.ID,
              patches: {
                Tags: record.Tags?.filter((x) => x !== tag),
              },
            })
          }
        >
          {tags.find((x) => x.ID === tag)?.Name ?? tag}
        </Tag>
      ))}

      {(availableTags?.length ?? 0) > 0 && (
        <Popover
          disabled={disabled}
          interactionKind="hover"
          transitionDuration={100}
          content={
            <Menu>
              <MenuDivider title="Select a tag" />
              {availableTags.map((tag) => (
                <MenuItem
                  disabled={isLoading}
                  key={tag.ID}
                  text={tag.Name}
                  onClick={() =>
                    patchCallRecord({
                      id: record.ID,
                      patches: {
                        Tags: [...(record?.Tags ?? []), tag.ID],
                      },
                    })
                  }
                />
              ))}
            </Menu>
          }
          placement="bottom"
        >
          <Button
            size="small"
            variant="minimal"
            icon="add"
            text="Add tag"
            disabled={disabled || isLoading}
          />
        </Popover>
      )}
    </div>
  );
}
